import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { submitServiceRequest } from '../services/submitServiceRequest';

function useConfirmationSubmit(serviceType, requestType) {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (event) => {
    event.preventDefault();
    setSubmitError('');
    setIsSubmitting(true);

    try {
      await submitServiceRequest(event.currentTarget, serviceType);
      navigate('/confirmation', { state: { requestType } });
    } catch (error) {
      console.error('Service request submission failed', error);
      setSubmitError(
        'We could not send your request. Please try again or email us directly.'
      );
      setIsSubmitting(false);
    }
  };

  return { handleSubmit, isSubmitting, submitError };
}

export default useConfirmationSubmit;
